module.exports = __webpack_public_path__ + "img/alert_deposit.288badc6.svg";